document.addEventListener('DOMContentLoaded', () => {
    const dropdown = document.querySelector('.client_form');
    const forms = document.querySelectorAll('.form-display');
    const formContainer = document.querySelector('.form-container');

    forms.forEach(form => form.style.display = 'none');

    dropdown.addEventListener('change', (event) => {
        formContainer.style.height = '0vh';
        formContainer.style.border = "none"
        const selectedFormId = event.target.value;

        forms.forEach(form => form.style.display = 'none');

        if (selectedFormId) {
            const selectedForm = document.getElementById(selectedFormId);
            if (selectedForm) {
                selectedForm.style.display = 'block';
                formContainer.style.height = '80vh';
                formContainer.style.border = "2px solid #9EFF36;"
            }
        }
    });

    forms.forEach(form => {
        form.addEventListener('submit', async (event) => {
            event.preventDefault(); // Prevent default form submission

            const formData = new FormData(form);
            // const payload = {};
            // formData.forEach((value, key) => {
            //     payload[key] = value;
            // });
            const payload = {};

            formData.forEach((value, key) => {
                if (key === "Acepto recibir noticias y correos electrónicos del Ferxxo.") {
                    // Replace "on" with "Accepted" and "off" with "Declined"
                    payload[key] = value === "on" ? "Accepted" : "Declined";
                } else {
                    payload[key] = value; // Keep other values unchanged
                }
            });

            const apiUrls = {
                "australia-form": "https://formbuilder.hulkapps.com/forms/create_response/9cf_fCQR0iZ0_31WcMEM0g",
                "asia-form": "https://formbuilder.hulkapps.com/forms/create_response/lb0q9BbadFIrsOyYzGYbdA",
                "latin-america-form": "https://formbuilder.hulkapps.com/forms/create_response/Z7g08rkzmk19VXB0Vi7xRg",
                "norte-america-form": "https://formbuilder.hulkapps.com/forms/create_response/YaySuAggGM0uC9AOmZKZug",
                "europe-form": "https://formbuilder.hulkapps.com/forms/create_response/BtOw2k2S-jJBCU146aopmg"
            };

            const apiUrl = apiUrls[form.id];

            if (apiUrl) {
                try {
                    const response = await fetch(apiUrl, {
                        method: 'POST',
                        headers: {
                            "X-Form-Access-Token": "264557399791ab9f",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ formResponse: payload })
                    });

                    const result = await response.json();
                    if (response.ok) {
                        alert('Listo el registro mor. Pendiente pues por las redes sociales y despues te mandamos un correo electronico cuando salgan a las ventas.');
                        location.reload();
                    } else {
                        console.error('Form submission failed:', result);
                        alert('Form submission failed. Please try again.');
                    }
                } catch (error) {
                    console.error('Error during form submission:', error);
                    alert('An error occurred. Please try again.');
                }
            } else {
                console.error('No API URL configured for this form:', form.id);
            }
        });
    });
});

